import React, { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import DocumentItem from '../common/DocumentItem';
import Accordion from '../common/Accordion';
import FilterBar from '../common/FilterBar'; // <-- Use the FilterBar
import { ViewContainer, ViewHeader, BackButton, ClientNameTitle } from './ClientDocumentView.styles';

const ClientDocumentView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { documents } = location.state || { documents: [] }; // Get docs from navigation state

  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');

  const filteredAndGroupedDocs = useMemo(() => {
    const filtered = documents.filter(doc => {
      const matchesSearch = doc.fileName.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesStatus = statusFilter === 'All' || doc.status === statusFilter;
      return matchesSearch && matchesStatus;
    });

    return filtered.reduce((acc, doc) => {
      (acc[doc.category] = acc[doc.category] || []).push(doc);
      return acc;
    }, {});
  }, [documents, searchTerm, statusFilter]);

  return (
    <ViewContainer>
      <ViewHeader>
        <BackButton onClick={() => navigate('/client/dashboard')}><ArrowLeft size={20} /></BackButton>
        <ClientNameTitle>My Documents</ClientNameTitle>
      </ViewHeader>
      
      <FilterBar
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        hideDateFilters={true} // <-- 3. Pass the new prop here
      />

      {Object.keys(filteredAndGroupedDocs).map(category => (
        <Accordion key={category} title={category}>
          {filteredAndGroupedDocs[category].map(doc => (
            <DocumentItem key={doc.id} document={doc} userRole="client" />
          ))}
        </Accordion>
      ))}
    </ViewContainer>
  );
};

export default ClientDocumentView;